/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { getMasterDataset } from "../actions/adminDashboardAction";

const initialState: any = {};

const masterDatasetSlice = createSlice({
  name: "Get the master dataset",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMasterDataset.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getMasterDataset.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getMasterDataset.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default masterDatasetSlice.reducer;
